import styled from 'styled-components';
import { Text } from '../text/index.js';
export const HeadingElement = styled(Text) ``;
//# sourceMappingURL=heading.styles.js.map